import { AlertCard } from 'components/WeatherAlerts/AlertCard';
import WidgetTimeUpdate from 'components/Widgets/WidgetTimeUpdate';
import { Button } from 'react-bootstrap';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
import { Polygon, useMap } from 'react-leaflet';
import { useState } from 'react';
import FullScreenMap from 'components/FullScreenMap';

const AlertWidget = ({
  hasMap = false,
  ROUTE,
  filteredAlertListPaged,
  dimensions,
  maxDist,
  alertsList,
  setAlertsList,
  sidebarOpen,
  preview = false,
}) => {
  const [mapCenter, setMapCenter] = useState(null);
  const [mapPolygon, setMapPolygon] = useState(null);
  const [selectedAlert, setSelectedAlert] = useState(null);
  const navigate = useNavigate();
  const isSquareWidget = dimensions?.[0] === 1 && dimensions?.[1] === 1;
  const isTallWidget = dimensions?.[0] === 1 && dimensions?.[1] === 2;
  const isWideWidget = dimensions?.[0] === 2 && dimensions?.[1] === 1;
  const mapPreviewHeight = isTallWidget ? 160 : 0;

  function ChangeView({ center, bounds }) {
    const map = useMap();
    map.setView(center, map.getBoundsZoom(bounds));
  }

  return (
    <div className="h-100 d-flex flex-column">
      <WidgetTimeUpdate route={ROUTE} realtime />
      {hasMap && mapCenter && mapPolygon && (
        <div
          className="position-relative w-100 rounded-3 overflow-hidden mb-2 flex-shrink-0"
          style={{ height: mapPreviewHeight, minHeight: mapPreviewHeight }}
        >
          <FullScreenMap
            sidebarOpen={sidebarOpen}
            mapCenter={mapCenter}
            zoom={11}
            showMapSat={false}
            classNameStyle="position-absolute bottom-0 start-0 z-2 ms-1 mb-1 d-inline-flex flex-nowrap"
            cssStyle={{ margin: 0 }}
            preview={preview}
          >
            <ChangeView center={mapCenter} bounds={mapPolygon} />
            {mapPolygon.map((poly, index) => (
              <Polygon key={index} positions={poly} />
            ))}
          </FullScreenMap>
        </div>
      )}
      <div
        className="d-flex align-items-center mt-2 mb-1 px-1"
        style={{
          fontSize: isSquareWidget ? '0.85rem' : isWideWidget ? '0.9rem' : '0.9rem',
          lineHeight: 1.1,
        }}
      >
        <p className="mb-0 flex-grow-1 flex-shrink-1 flex-basis-3xs">Severity</p>
        <p className="mb-0 flex-grow-1 flex-shrink-1 flex-basis-3xs">Type</p>
        <p className="mb-0 flex-grow-1 flex-shrink-1 flex-basis-3xs">Sender</p>
      </div>
      <div className="w-100 overflow-auto flex-grow-1" style={{ minHeight: 0 }}>
        {filteredAlertListPaged.length === 0 && (
          <div className="w-100 text-center">No Results Found...</div>
        )}
        {filteredAlertListPaged.map((alert, index) => (
          <AlertCard
            key={index}
            widget
            dimensions={dimensions}
            index={index}
            alert={alert}
            getAlerts={() => {
              setAlertsList(alertsList.filter((a) => a !== alert));
            }}
            canCloseAlert={parseInt(alert.workplaceId) === parseInt(Cookies.get('workplaceId'))}
            maxDistance={maxDist}
            setMapPolygon={setMapPolygon}
            setMapCenter={setMapCenter}
            selectedAlert={selectedAlert}
            setSelectedAlert={setSelectedAlert}
          />
        ))}
      </div>
      <div
        className={`mb-2 d-flex w-100 align-items-stretch mt-2 gap-2 flex-shrink-0 ${
          isWideWidget ? 'flex-row' : 'flex-column'
        } ${dimensions[0] < 2 ? 'justify-content-center' : ''}
        `}
        style={{
          paddingBottom: isTallWidget ? 0 : undefined,
          fontSize: isWideWidget ? '1rem' : '0.95rem',
        }}
      >
        <Button
          className="m-0 px-3 py-2 rounded-3 w-100"
          style={{ fontSize: 'inherit', lineHeight: 1.2 }}
          onClick={() => navigate('/publicuser/alerts')}
          variant="primary"
        >
          All Alerts
        </Button>
        <Button
          className="m-0 px-3 py-2 rounded-3 w-100"
          style={{ fontSize: 'inherit', lineHeight: 1.2 }}
          onClick={() => navigate('/publicuser/createAlert')}
          variant="primary"
        >
          Create Alert
        </Button>
      </div>
    </div>
  );
};

export default AlertWidget;
